import { IBienLaiViewActionTypes } from "../../action-types/bien-lai/IBienLaiViewActionTypes";
import {
  IBienLaiViewReducer,
  IBienLaiViewSinhVienReducer,
} from "../../reducer-model/bien-lai/IBienLaiViewReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiViewReducer = {
  sinhViens: [],
};
export const bienLaiViewReducer = (
  state: IBienLaiViewReducer = iniState,
  action: IBienLaiViewActionTypes
): IBienLaiViewReducer => {
  switch (action.type) {
    case "BIEN_LAI_VIEW_LOAD_START":
      const resquest = action.payload;
      const { hoc_ky, nam_hoc, id_sv } = resquest;
      const sinhVienReducerExisted = state.sinhViens.find(
        (x) => x.hoc_ky === hoc_ky && x.nam_hoc === nam_hoc && x.id_sv === id_sv
      );
      const sinhVienReducer: IBienLaiViewSinhVienReducer =
        sinhVienReducerExisted ?? {
          bienLais: [],
          hoc_ky,
          nam_hoc,
          id_sv,
          id_lop: 0,
          idSelections: [],
          status: eReducerStatusBase.is_loading,
        };
      return {
        ...state,
        sinhViens: [
          sinhVienReducer,
          ...state.sinhViens.filter(
            (x) =>
              x.hoc_ky !== hoc_ky || x.nam_hoc !== nam_hoc || x.id_sv !== id_sv
          ),
        ].map((x) => {
          if (
            x.hoc_ky === hoc_ky &&
            x.nam_hoc === nam_hoc &&
            x.id_sv === id_sv
          ) {
            return { ...x, status: eReducerStatusBase.is_loading };
          }
          return x;
        }),
      };
    case "BIEN_LAI_VIEW_LOAD_SUCCESS":
      return {
        ...state,
        sinhViens: state.sinhViens.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_sv === action.payload.request.id_sv
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_completed,
              bienLais: action.payload.data,
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_LOAD_ERRR":
      return {
        ...state,
        sinhViens: state.sinhViens.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_sv === action.payload.request.id_sv
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_completed,
              bienLais: [],
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_SELECTED_ID":
      return {
        ...state,
        sinhViens: state.sinhViens.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_sv === action.payload.request.id_sv
          ) {
            return {
              ...sv,
              idSelections: action.payload.data,
            };
          }
          return sv;
        }),
      };
    default:
      return state;
  }
};
